import './ccf-call-reslove-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfCallResloveIconProps extends SvgIconProps {}
/**
 * Component used to display resolved state Icon
 * @param props - CcfCallResloveIconProps
 * @example - <CcfCallResloveIcon />
 * @returns SVG of call resolved icon
 */
export function CcfCallResloveIcon(props: CcfCallResloveIconProps) {
  return (
    <SvgIcon {...props}>
        <g id="Resolve">
    <path id="Path_13194" data-name="Path 13194" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm5.207,7.613L11.019,15.8a1,1,0,0,1-1.414,0L6.793,12.988a1,1,0,1,1,1.414-1.414l2.105,2.105,5.48-5.48a1,1,0,1,1,1.414,1.414Z" transform="translate(-2 -2)"/>
  </g>
    </SvgIcon>
  );
}

export default CcfCallResloveIcon;